import React from 'react';

import { JOURNEYS_ICON } from '@lumapps/journeys/constants';
import { journeyRoutes } from '@lumapps/journeys/routes';
import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { useSelector } from '@lumapps/redux/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { canAccessJourneysAdmin } from '../../ducks/selectors';
import { JOURNEY_ADMIN } from '../../keys';

export const JourneysSideNavigation = (props: Partial<SideNavigationItemProps>) => {
    const isAllowed = useSelector(canAccessJourneysAdmin);

    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem {...props} label={translateKey(GLOBAL.JOURNEYS)} icon={JOURNEYS_ICON} id="journeys">
            <SideNavigationItem
                label={translateKey(JOURNEY_ADMIN.SIDE_NAV_TITLE)}
                route={journeyRoutes.baseRoute}
                excludedRoutes={[journeyRoutes.settingsRoute]}
            />
            <SideNavigationItem label={translateKey(GLOBAL.SETTINGS)} route={journeyRoutes.settingsRoute} />
        </SideNavigationItem>
    );
};

JourneysSideNavigation.displayName = 'SideNavigationItem';
